webpackJsonp([114276838955818,60335399758886],{

/***/ 118:
/***/ (function(module, exports) {

	module.exports = {"data":{"pages":{"edges":[{"node":{"fields":{"slug":"/share-button/","prefix":"1"},"frontmatter":{"title":"<ShareButton />"}}},{"node":{"fields":{"slug":"/share-block/","prefix":"2"},"frontmatter":{"title":"<ShareBlock />"}}},{"node":{"fields":{"slug":"/share-block-standard/","prefix":"3"},"frontmatter":{"title":"<ShareBlockStandard />"}}},{"node":{"fields":{"slug":"/share-block-aside/","prefix":"4"},"frontmatter":{"title":"<ShareBlockAside />"}}},{"node":{"fields":{"slug":"/share-button-rectangle/","prefix":"5"},"frontmatter":{"title":"<ShareButtonRectangle />"}}},{"node":{"fields":{"slug":"/share-button-circle/","prefix":"6"},"frontmatter":{"title":"<ShareButtonCircle />"}}},{"node":{"fields":{"slug":"/share-button-icon-only/","prefix":"7"},"frontmatter":{"title":"<ShareButtonIconOnly />"}}},{"node":{"fields":{"slug":"/share-button-round-square/","prefix":"8"},"frontmatter":{"title":"<ShareButtonRoundSquare />"}}},{"node":{"fields":{"slug":"/share-button-outline/","prefix":"9"},"frontmatter":{"title":"<ShareButtonOutline />"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(44);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(118);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(4);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	  var theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "footer",
	      {
	        className: _style2.default.dynamic([["1733722926", [theme.color.neutral.white, theme.space.inset.default, theme.color.neutral.gray.g, theme.font.size.xxs, theme.space.xxs, theme.space.s, "calc(" + theme.space.xs + " * -1)"]]]) + " " + "footer"
	      },
	      _react2.default.createElement(
	        "ul",
	        {
	          className: _style2.default.dynamic([["1733722926", [theme.color.neutral.white, theme.space.inset.default, theme.color.neutral.gray.g, theme.font.size.xxs, theme.space.xxs, theme.space.s, "calc(" + theme.space.xs + " * -1)"]]])
	        },
	        _react2.default.createElement(
	          "li",
	          {
	            className: _style2.default.dynamic([["1733722926", [theme.color.neutral.white, theme.space.inset.default, theme.color.neutral.gray.g, theme.font.size.xxs, theme.space.xxs, theme.space.s, "calc(" + theme.space.xs + " * -1)"]]])
	          },
	          "check ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://dev.greglobinski.com", className: _style2.default.dynamic([["1733722926", [theme.color.neutral.white, theme.space.inset.default, theme.color.neutral.gray.g, theme.font.size.xxs, theme.space.xxs, theme.space.s, "calc(" + theme.space.xs + " * -1)"]]])
	            },
	            "Front-end web development with Greg"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "1733722926",
	      css: [".footer.__jsx-style-dynamic-selector{background:" + theme.color.neutral.white + ";padding:" + theme.space.inset.default + ";padding-top:0;padding-bottom:120px;}", ".footer.__jsx-style-dynamic-selector ul{list-style:none;text-align:center;padding:0;}", ".footer.__jsx-style-dynamic-selector ul li{color:" + theme.color.neutral.gray.g + ";font-size:" + theme.font.size.xxs + ";padding:" + theme.space.xxs + " " + theme.space.s + ";position:relative;display:inline-block;}", ".footer.__jsx-style-dynamic-selector ul li:after{content:\"\u2022\";position:absolute;right:" + ("calc(" + theme.space.xs + " * -1)") + ";}", ".footer.__jsx-style-dynamic-selector ul li:last-child:after{content:\"\";}", "@media screen and (min-width:1024px){.footer.__jsx-style-dynamic-selector{padding:0 1em 1.5em;}}"],
	      dynamic: [theme.color.neutral.white, theme.space.inset.default, theme.color.neutral.gray.g, theme.font.size.xxs, theme.space.xxs, theme.space.s, "calc(" + theme.space.xs + " * -1)"]
	    })
	  );
	};
	
	Footer.propTypes = {
	  html: _propTypes2.default.string,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Footer = __webpack_require__(40);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Footer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(4);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fixed: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "header",
	        {
	          className: "jsx-4096391115"
	        },
	        _react2.default.createElement(
	          "h1",
	          {
	            className: "jsx-4096391115"
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            "react-custom-share"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            className: "jsx-4096391115"
	          },
	          _react2.default.createElement(
	            "a",
	            { href: "https://github.com/greglobinski/react-custom-share", className: "jsx-4096391115"
	            },
	            "github"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.npmjs.com/package/react-custom-share", className: "jsx-4096391115"
	            },
	            "npm"
	          )
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "4096391115",
	        css: ["header.jsx-4096391115{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:2em 0 1em;position:relative;top:0;width:100%;}", "h1.jsx-4096391115{font-size:25px;}", "p.jsx-4096391115{padding:1em 0 0;}", "p.jsx-4096391115 a{margin:0 1em;}"]
	      })
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  pages: _propTypes2.default.array.isRequired,
	  path: _propTypes2.default.string.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(42);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.postQuery = exports.FontLoadedContext = exports.ScreenWidthContext = exports.ThemeContext = undefined;
	
	var _style = __webpack_require__(4);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(41);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(43);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	__webpack_require__(53);
	
	var _theme = __webpack_require__(55);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemeContext = exports.ThemeContext = _react2.default.createContext(null);
	var ScreenWidthContext = exports.ScreenWidthContext = _react2.default.createContext(0);
	var FontLoadedContext = exports.FontLoadedContext = _react2.default.createContext(false);
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      theme: _theme2.default
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data;
	    var pages = data.pages.edges;
	
	
	    return _react2.default.createElement(
	      ThemeContext.Provider,
	      { value: this.state.theme },
	      _react2.default.createElement(
	        FontLoadedContext.Provider,
	        { value: this.state.font400loaded },
	        _react2.default.createElement(
	          ScreenWidthContext.Provider,
	          { value: this.state.screenWidth },
	          _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_Header2.default, { path: this.props.location.pathname, pages: pages, theme: this.state.theme }),
	            _react2.default.createElement(
	              "main",
	              {
	                className: "jsx-3301783272"
	              },
	              children()
	            ),
	            _react2.default.createElement(_Footer2.default, { theme: this.state.theme }),
	            _react2.default.createElement(_style2.default, {
	              styleId: "1304903616",
	              css: ["main.jsx-3301783272{min-height:80vh;}"]
	            }),
	            _react2.default.createElement(_style2.default, {
	              styleId: "1368345057",
	              css: ["html{-webkit-box-sizing:border-box;box-sizing:border-box;}", "*,*:after,*:before{-webkit-box-sizing:inherit;box-sizing:inherit;margin:0;padding:0;}", "body{font-family:\"Open Sans\",sans-serif;}", "h1,h2,h3{font-weight:600;line-height:1.1;-webkit-letter-spacing:-0.03em;-moz-letter-spacing:-0.03em;-ms-letter-spacing:-0.03em;letter-spacing:-0.03em;margin:0;}", "h1{-webkit-letter-spacing:-0.04em;-moz-letter-spacing:-0.04em;-ms-letter-spacing:-0.04em;letter-spacing:-0.04em;}", "p{margin:0;}", "strong{font-weight:600;}", "a{-webkit-text-decoration:none;text-decoration:none;color:#666;}", "main{width:auto;display:block;}"]
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func,
	  data: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.object.isRequired
	};
	
	exports.default = Layout;
	
	//eslint-disable-next-line no-undef
	
	var postQuery = exports.postQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	module.exports = {"space":{"default":"20px","xxs":"2px","xs":"5px","s":"10px","m":"20px","l":"40px","xl":"80px","inset":{"default":"20px","xs":"5px","s":"10px","m":"20px","l":"40px"},"stack":{"default":"0 0 20px 0","xxs":"0 0 2px 0","xs":"0 0 5px 0","s":"0 0 10px 0","m":"0 0 20px 0","l":"0 0 40px 0"},"inline":{"default":"0 20px 0 0","xxs":"0 2px 0 0","xs":"0 5px 0 0","s":"0 10px 0 0","m":"0 20px 0 0","l":"0 40px 0 0"}},"size":{"radius":{"default":"10px","small":"5px"}},"color":{"neutral":{"white":"#ffffff","gray":{"a":"#fafaf9","b":"#f3f2f2","c":"#ecebea","d":"#dddbda","e":"#c9c7c5","f":"#b0adab","g":"#969492","h":"#706e6b","i":"#514f4d","j":"#3e3e3c","k":"#2b2826"},"black":"#000000"},"brand":{"primary":"#709425","primaryActive":"#709425","light":"#709425","lightActive":"#709425","dark":"#709425","darkActive":"#709425"},"special":{"attention":"orange"}},"font":{"family":{"initial":"Arial, sans-serif","target":"Open Sans"},"weight":{"standard":400,"bold":600},"size":{"xxs":".8em","xs":".95em","s":"1.1em","m":"1.35em","l":"1.7em","xl":"2em","xxl":"2.2em","xxxl":"2.8em"},"lineHeight":{"xs":1.1,"s":1.2,"m":1.3,"l":1.4,"xl":1.5,"xxl":1.6,"reset":1}},"time":{"duration":{"default":"0.5s","long":"1s"}},"background":{"color":{"primary":"#ffffff","alt":"#fafaf9","brand":"#709425"}},"text":{"family":"Open Sans","color":{"primary":"#3e3e3c","primaryInverse":"#ffffff","brand":"#709425","attention":"orange"},"lineHeight":{"default":1.6},"maxWidth":{"tablet":"650px","desktop":"700px"}},"heading":{"family":"Open Sans","size":{"h1":"2.2em","h2":"1.7em","h3":"1.35em"},"lineHeight":{"h1":1.1,"h2":1.1,"h3":1.1},"weight":600},"line":{"color":"#ecebea"},"icon":{"color":"#709425"},"hero":{"h1":{"size":"2.8em","color":"#ffffff","lineHeight":1.1},"background":"linear-gradient(0deg, #E0306E, #6438B5)"},"blog":{"h1":{"size":"1.35em","lineHeight":1.1,"hoverColor":"#709425"}},"header":{"height":{"default":"80px","fixed":"50px;","homepage":"100px;"}}}

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9ea8e4c92d35184af14e.js